import React from 'react';
import cn from 'classnames';
import QuestionAlertsComponent from '@dataroom/email-alerts/ui/QuestionAlerts';
import QuestionAlertsTypeSwitcher, { QuestionAlertsType } from '@dataroom/email-alerts/ui/QuestionAlertsTypeSwitcher';
import Spinner from '@dealroadshow/uikit-loader/Spinner';
import { ITimezone } from '@framework/timezone/vo/Timezone';
import {
  IQuestionsNotificationSettingsPayload,
  IQuestionsRealtimeNotificationSettingsPayload,
} from '@dataroom/email-alerts/domain/vo/QuestionsEmailAlerts';
import styles from './questionAlerts.module.scss';

interface IProps {
  initialValues: IQuestionsNotificationSettingsPayload,
  initialRealtimeValues: IQuestionsRealtimeNotificationSettingsPayload,
  timezone: ITimezone,
  onChange: (v: IQuestionsNotificationSettingsPayload) => void,
  onRealtimeChange?: (values: IQuestionsRealtimeNotificationSettingsPayload) => void,
  isFetching: boolean,
  alertsTypeValue: QuestionAlertsType,
  onTypeChange: (type: QuestionAlertsType) => void,
  isQuestionManager: boolean,
  realtimeError: string,
  setRealtimeError: (error: string) => void,
}

const QuestionAlerts = ({
  initialValues,
  timezone,
  onChange,
  isFetching,
  alertsTypeValue,
  onTypeChange,
  initialRealtimeValues,
  onRealtimeChange,
  isQuestionManager,
  realtimeError,
  setRealtimeError,
}: IProps) => (
  <div className={ styles.wrapper }>
    <div className={ styles.title }>
      Q&A Alerts
    </div>
    <div className={ styles.container }>
      <div className={ styles.alertsTitle }>
        Q&A Alerts provide status reports on questions submitted to the data room, directly by email.
      </div>
      <QuestionAlertsComponent
        initialValues={ initialValues }
        initialRealtimeValues={ initialRealtimeValues }
        timezone={ timezone }
        onChange={ onChange }
        onRealtimeChange={ onRealtimeChange }
        isQuestionManager={ isQuestionManager }
        realtimeError={ realtimeError }
        setRealtimeError={ setRealtimeError }
      />
    </div>
    <div className={ cn(styles.container, styles.bottomSection) }>
      <div className={ styles.alertsTitle }>
        Select which Q&A email alerts on this data room you’ll receive emails notifications for:
      </div>
      <QuestionAlertsTypeSwitcher
        value={ alertsTypeValue }
        onChange={ onTypeChange }
        isQuestionManager={ isQuestionManager }
      />
    </div>
    <Spinner
      overlay
      isVisible={ isFetching }
    />
  </div>
);

export default QuestionAlerts;
